<section class="tickets-toolbar">
  <div class="tickets-toolbar__meta tickets-toolbar__meta--left">
    <span>{{ totalIncidencias }} defectos</span>
    <strong>Historico general</strong>
  </div>

  <div class="tickets-toolbar__note">
    Datos consolidados desde las graficas actuales de incidencias QA.
  </div>
</section>

<div class="tickets-alert" *ngIf="incidenciaErrorCarga">
  {{ incidenciaErrorCarga }}
</div>

<section class="tickets-kpis tickets-kpis--incidents" aria-label="Indicadores principales de defectos">
  <article class="ticket-kpi" *ngFor="let kpi of incidenciaKpis" [ngClass]="kpi.className">
    <div class="ticket-kpi__icon">
      <mat-icon>{{ kpi.icon }}</mat-icon>
    </div>
    <div>
      <span>{{ kpi.label }}</span>
      <strong>{{ kpi.value }}</strong>
      <small>{{ kpi.meta }}</small>
    </div>
  </article>

  <div class="tickets-loading-card" *ngIf="cargando && incidenciaKpis.length === 0">
    Actualizando indicadores...
  </div>
</section>

<section class="tickets-grid">
  <article class="tickets-card tickets-card--status">
    <div class="tickets-card__header">
      <div>
        <span>Flujo QA</span>
        <h2>Defectos por estatus</h2>
      </div>
    </div>

    <div class="tickets-status">
      <div class="tickets-donut" [ngStyle]="getIncidentDonutStyle()">
        <div class="tickets-donut__center">
          <strong>{{ totalIncidencias }}</strong>
          <span>Total</span>
        </div>
      </div>

      <div class="tickets-status__legend">
        <div class="tickets-status__item" *ngFor="let item of incidenciaEstatusItems">
          <span class="tickets-status__dot" [style.background]="item.color"></span>
          <span>{{ item.nombre }}</span>
          <strong>{{ item.valor }}</strong>
        </div>
      </div>
    </div>

    <div class="tickets-empty" *ngIf="!cargando && incidenciaEstatusItems.length === 0">
      No hay incidencias para mostrar.
    </div>
  </article>

  <article class="tickets-card">
    <div class="tickets-card__header">
      <div>
        <span>Proyectos</span>
        <h2>Mayor concentracion</h2>
      </div>
    </div>

    <div class="tickets-bars" *ngIf="incidenciaProyectoItems.length > 0; else emptyIncProyectosTpl">
      <div class="tickets-bar" *ngFor="let item of incidenciaProyectoItems; let i = index">
        <div class="tickets-bar__row">
          <span>{{ item.nombre || 'Sin proyecto' }}</span>
          <strong>{{ getIncidentBarPercent(item) }}%</strong>
        </div>
        <div class="tickets-bar__track">
          <span [ngStyle]="getIncidentBarStyle(item, i)"></span>
        </div>
        <small>{{ item.valor }} defectos</small>
      </div>
    </div>
  </article>
</section>

<section class="tickets-grid tickets-grid--secondary">
  <article class="tickets-card">
    <div class="tickets-card__header">
      <div>
        <span>Tendencia</span>
        <h2>Actividad por mes</h2>
      </div>
    </div>

    <div class="incident-months" *ngIf="incidenciaMesItems.length > 0; else emptyIncMesesTpl">
      <div class="incident-month" *ngFor="let item of incidenciaMesItems; let i = index">
        <span>{{ item.nombre }}</span>
        <div class="incident-month__bar">
          <span [ngStyle]="getIncidentBarStyle(item, i, incidenciaMesMax)"></span>
        </div>
        <strong>{{ item.valor }}</strong>
      </div>
    </div>
  </article>

  <article class="tickets-card">
    <div class="tickets-card__header">
      <div>
        <span>Lectura rapida</span>
        <h2>Prioridades de atencion</h2>
      </div>
    </div>

    <div class="incident-summary">
      <div>
        <strong>{{ getIncidentStatusCount('ABIERTO') + getIncidentStatusCount('PROCESO') }}</strong>
        <span>Defectos que requieren seguimiento inmediato.</span>
      </div>
      <div>
        <strong>{{ getIncidentStatusCount('REVISION') + getIncidentStatusCount('OBSERVACIONES') }}</strong>
        <span>Casos en validacion o esperando ajustes.</span>
      </div>
      <div>
        <strong>{{ getIncidentStatusCount('RESUELTO') + getIncidentStatusCount('VOBO') }}</strong>
        <span>Casos cerrados funcionalmente o con visto bueno.</span>
      </div>
    </div>
  </article>
</section>

<ng-template #emptyIncProyectosTpl>
  <div class="tickets-empty">No hay distribucion por proyecto disponible.</div>
</ng-template>

<ng-template #emptyIncMesesTpl>
  <div class="tickets-empty">No hay tendencia mensual disponible.</div>
</ng-template>
